import { DBFactory } from "~/classes/database/db_factory";
import { BaseModel } from "../base.model";

export type Students = Student[];

export type StudentContact = {
  label: string;
  email: string;
};

type StudentConstrutorParams = {
  id?: string;
  externalId: string;
  externalProvider: "sakai" | "google" | "canvas" | "iew";
  name: string;
  userId: string;
  classroomIds: string[];
  classroomName: string;
  externalStudentData: { [key: string]: any };
  enableStyleOverrides: boolean;
  availableStyleCriteria?: string[];
  isArchived: boolean;
  excusedCriteria?: string[];
};
export class Student extends BaseModel {
  id?: string = "";
  externalId: string;
  externalProvider: "sakai" | "google" | "canvas" | "iew" = "iew";
  name: string = "";
  userId: string = "";
  classroomIds;
  classroomName: string = "";
  externalStudentData: { [key: string]: any } = {};
  enableStyleOverrides: boolean = false;
  availableStyleCriteria?: string[];
  isArchived: boolean = false;
  excusedCriteria: string[];

  constructor(data: StudentConstrutorParams) {
    super();

    this.id = data.id;
    this.externalId = data.externalId;
    this.externalProvider = data.externalProvider;
    this.name = data.name;
    this.userId = data.userId;
    this.classroomIds = data.classroomIds;
    this.classroomName = data.classroomName;
    this.externalStudentData = data.externalStudentData;
    this.enableStyleOverrides = data.enableStyleOverrides;
    this.availableStyleCriteria = data.availableStyleCriteria;
    this.isArchived = data.isArchived;
    this.excusedCriteria = data.excusedCriteria ?? [];

    this.modelDatabaseConfig = {
      collection: "/students",
      path: `/students/${this.id}`,
    };
  }
  override toMap(): ModelDatabaseData {
    return super.toMap();
  }

  static default(userId: string, classroomId: string, classroomName: string) {
    return new Student({
      name: "",
      userId: userId,
      classroomIds: [classroomId],
      classroomName: classroomName,
      externalId: "",
      externalProvider: "iew",
      externalStudentData: {},
      enableStyleOverrides: false,
      isArchived: false,
    });
  }

  static override fromMap(map: any): Student {
    const instance = new Student(map);
    return instance;
  }

  get firstName(): string {
    return this.name.split(" ")[0];
  }

  get initials(): string {
    // Remove all non-letter characters and split by spaces
    const cleaned = this.name
      .replace(/[^a-zA-Z\s]/g, "")
      .replace(/\s+/g, " ")
      .trim();
    const names = cleaned.split(" ").filter(Boolean);
    let first = "";
    let last = "";
    if (names.length === 0) {
      return "";
    } else if (names.length === 1) {
      first = last = names[0][0] || "";
    } else {
      first = names[0][0] || "";
      last = names[names.length - 1][0] || "";
    }
    return (first + last).toUpperCase();
  }

  save = async () => {
    const db = DBFactory.createDatabase();
    this.id = await db.save(this.toMap(), this.modelDatabaseConfig);
  };

  delete = async () => {
    const db = DBFactory.createDatabase();
    await db.delete(this.modelDatabaseConfig);
  };
}
